// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1KuEG","detailsBorder":"styles_detailsBorder__2MtuW"};